/** User-facing copy a store keeps. A function is translated every time the copy is
 *  read, so a message on screen follows a language switch instead of staying in the
 *  language it was raised in; a plain string (a server message) is shown as is. */
export type LocalizedText = string | (() => string);

export const resolveText = (text: LocalizedText): string =>
    typeof text === 'function' ? text() : text;
